<template>
  <div id="container" class="member_st">
    <!-- 개인정보수정 & sub menu -->
    <AccountHead />

    <!-- 리뷰 START -->
    <div class="review_detail">
      <div
        v-if="!isAccountReviewLoading && !getAccountReviews"
        id="reviewEmpty"
        class="section fill"
      >
        <div class="inner">
          <div class="empty">
            <div>
              <img src="@/assets/images/myreview_empty.jpg" alt="" />
            </div>
            <p>{{ $t('views.member.reviews.6271') }}</p>
          </div>
        </div>
      </div>

      <div
        v-if="!isAccountReviewLoading && getAccountReviews"
        id="reviewResult"
        class="section fill"
      >
        <div class="inner">
          <div class="box_title">
            <h2>{{ $t('views.member.reviews.12') }}</h2>
            <!-- <p class="guide_txt">{{ $t('views.member.reviews.1166') }}</p> -->
          </div>

          <div class="mypage_detail">
            <!-- <div
              v-for="(date, idx) in Object.keys(formattedReviews)"
              :key="idx"
              class="box"
            > -->
            <div v-for="(data, idx) in formattedReviews" :key="idx" class="box">
              <div class="order_title">
                <dl class="">
                  <dt>{{ $t('views.member.reviews.1215') }}</dt>
                  <dd>
                    <span class="year">{{ data.creDtime }}</span>
                  </dd>
                </dl>
              </div>
              <ul class="order_book">
                <!-- REVIEWS WITHIN A SPECIFIC DATE -->
                <!-- <li
                  v-for="(review, reviewIdx) in formattedReviews[date]"
                  :key="reviewIdx"
                > -->
                <li>
                  <div class="info_wrap">
                    <!-- TODO: @Stan ROUTER PATH (NAME) SHOULD CHANGE DEPENDING ON WHAT KIND OF BOOK WAS REVIEWED: selfbook => selfbook_detail, 교재 => book_detail, enote => enote_detail -->
                    <router-link
                      :to="{
                        name: 'book_detail',
                        params: { id: data.bookCd }
                      }"
                    >
                      <h3 class="meta_title">
                        {{ data.bookNm }}
                      </h3>
                      <span
                        v-if="data.purchasedYn === 'Y'"
                        class="reviewer_meta_state active"
                      >
                        {{ $t('views.member.reviews.purchase') }}
                      </span>
                      <span
                        v-if="data.purchasedYn === 'N'"
                        class="reviewer_meta_state"
                        >{{ $t('views.member.reviews.3221') }}</span
                      >
                    </router-link>
                    <p class="review_text">
                      {{ data.review }}
                    </p>
                  </div>
                  <div class="review_score_box">
                    <div class="review_score_area cell">
                      <star-rating
                        :rating="data.score"
                        active-color="#FBE116"
                        :star-size="starSize"
                        :increment="increment"
                        :show-rating="showRating"
                        :read-only="readOnly"
                      />
                    </div>
                  </div>
                  <div class="btn_wrap">
                    <div class="cell">
                      <a class="box_btn dull" @click="openUpdateModal(data)"
                        ><span class="an_t">{{
                          $t('views.member.reviews.edit')
                        }}</span></a
                      >
                      <a class="box_btn line" @click="openDeleteModal(data)"
                        ><span class="an_t">{{
                          $t('views.member.reviews.delete')
                        }}</span></a
                      >
                    </div>
                  </div>
                </li>
                <!-- End Review Date -->
              </ul>
            </div>
            <Pagination
              :current-page="currentPage"
              :total-count="getAccountReviewTotalCount"
              :item-per-page="booksPerPage"
              @paginate="paginate"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 리뷰 END -->

    <!-- UPDATE REVIEW MODAL START -->
    <transition name="modal-fade">
      <Modal v-if="showUpdateModal" @close="toggleUpdateModal">
        <div class="ly_pop_content ly_pop_msg ly_txt">
          <div class="ly_pop_head">
            <a class="btn_ly_close svg_close" @click="toggleUpdateModal"
              ><span>{{ $t('library.deletemodal.close') }}</span></a
            >
          </div>
          <div class="ly_inner">
            <p class="tac" style="margin-bottom: 15px; text-align: left;">
              {{ $t('views.member.reviews.6612') }}
            </p>

            <!-- Review 작성 -->
            <form class="review_input_form">
              <div class="review_text_wrap" style="background-color: #fff;">
                <textarea
                  v-model="updatedReview.review"
                  :placeholder="$t('views.member.reviews.2577')"
                  class="review_input_t correct-border"
                  name="review"
                  maxlength="500"
                ></textarea>
              </div>

              <div class="review_bottom_wrap">
                <!-- Review 별점 -->
                <div
                  class="review_score_box"
                  style="display: flex; align-items: flex-end; margin-top: 5px;"
                >
                  <div class="l_box">
                    <span class="review_score_txt">{{
                      $t('views.member.reviews.rating')
                    }}</span>
                    <div class="review_score_area">
                      <star-rating
                        class="star-rating"
                        :rating="updatedReview.score"
                        active-color="#FBE116"
                        :star-size="fetchWidth"
                        :increment="increment"
                        :show-rating="showRating"
                        @rating-selected="setRating"
                      />
                    </div>
                  </div>

                  <div class="review_btn_wrap">
                    <div class="review_write_wrap">
                      <button class="box_btn" @click.prevent="updateReview">
                        <span class="an_t">{{
                          $t('views.member.reviews.saveedit')
                        }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <!-- Review 작성 -->
          </div>
        </div>
      </Modal>
    </transition>
    <!-- UPDATE REVIEW MODAL END -->

    <!-- DELETE REVIEW MODAL START -->
    <transition name="modal-fade">
      <Modal v-if="showDeleteModal" @close="toggleDeleteModal">
        <div class="ly_pop_content ly_pop_msg ly_txt">
          <div class="ly_pop_head">
            <a class="btn_ly_close svg_close" @click="toggleDeleteModal"
              ><span>{{ $t('library.deletemodal.close') }}</span></a
            >
          </div>
          <div class="ly_inner">
            <p class="tac">{{ $t('views.member.reviews.2808') }}</p>

            <div class="btn_wrap">
              <button class="ModalBtn box_btn dull" @click="toggleDeleteModal">
                <span class="an_t">{{
                  $t('views.member.reviews.cancel')
                }}</span>
              </button>
              <button class="ModalBtn box_btn" @click="deleteReview">
                <span class="an_t">{{
                  $t('views.member.reviews.delete')
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
    <!-- DELETE REVIEW MODAL END -->
  </div>
</template>

<script>
import AccountHead from '@/components/member/AccountHead.vue'
import StarRating from 'vue-star-rating'

import {
  ACCOUNT_REVIEW_GET_LIST,
  ACCOUNT_REVIEW_DELETE,
  ACCOUNT_REVIEW_UPDATE
} from '@/store/types'

import { mapGetters } from 'vuex'

// import moment from 'moment'

export default {
  name: 'Reviews',
  components: {
    AccountHead,
    StarRating
  },
  data() {
    return {
      // For star-rating package
      currentPage: 1,

      booksPerPage: 10,
      starSize: 30,
      starSizeEdit: 28,
      increment: 0.5,
      showRating: false,
      readOnly: true,
      review: null,
      showDeleteModal: false,
      showUpdateModal: false,
      updatedReview: {},
      error: null,
      window: {
        width: 0
      }
    }
  },

  computed: {
    ...mapGetters([
      'getAccountReviews',
      'isAccountReviewLoading',
      'getAccountReviewTotalCount'
    ]),
    fetchWidth() {
      if (this.window.width < 340) {
        return 16
      }
      if (this.window.width < 400) {
        return 24
      }
      return 30
    }
    // formattedReviews() {
    //   if (!this.getAccountReviews) {
    //     return []
    //   }
    //   const formatted = this.getAccountReviews.map((review) => {
    //     return {
    //       ...review,
    //       creDtime: review.creDtime
    //         ? moment(review.creDtime).format('YYYY.MM.DD')
    //         : null
    //     }
    //   })
    //   // this.getAccountReviews.map((review) => {
    //   //   const date = review.creDtime
    //   //     ? moment(review.creDtime).format('YYYY.MM.DD')
    //   //     : null
    //   //   if (date && !formatted[date]) {
    //   //     formatted[date] = []
    //   //   }
    //   //   if (date) {
    //   //     formatted[date].push(review)
    //   //   }
    //   // })

    //   // return formatted
    //   return formatted
    // }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // if (!vm.getAccountReviews) {
      vm.$store.dispatch(ACCOUNT_REVIEW_GET_LIST, {})
      // }
    })
  },
  methods: {
    async paginate(page) {
      this.currentPage = page
      await this.$store.dispatch(ACCOUNT_REVIEW_GET_LIST, { page })
    },
    handleResize() {
      this.window.width = window.innerWidth
    },
    openUpdateModal(review) {
      this.updatedReview = {
        bookCd: review.bookCd,
        review: review.review,
        score: review.score
      }

      this.toggleUpdateModal()
    },
    toggleUpdateModal() {
      this.showUpdateModal = !this.showUpdateModal

      if (!this.showUpdateModal) {
        this.updatedReview = {}
      }
    },
    openDeleteModal(review) {
      this.review = review
      this.toggleDeleteModal()
    },
    toggleDeleteModal() {
      this.showDeleteModal = !this.showDeleteModal

      if (!this.showDeleteModal) {
        this.review = null
      }
    },
    setRating(rating) {
      this.updatedReview.score = rating
    },
    async deleteReview() {
      const { bookCd } = this.review
      const review = { bookCd }

      try {
        await this.$store.dispatch(ACCOUNT_REVIEW_DELETE, review)
        this.toggleDeleteModal()
      } catch (err) {
        this.error = err
      }
    },
    async updateReview() {
      try {
        this.$store.dispatch(ACCOUNT_REVIEW_UPDATE, this.updatedReview)
        this.toggleUpdateModal()
      } catch (err) {
        this.error = err
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.vue-star-rating {
  width: 100%;
  justify-content: center;
  position: relative !important;
}
.vue-star-rating-star {
  width: 60px !important;
}
// Fix Modal buttons
.ModalBtn {
  margin-left: 6px !important;
  margin-right: 6px !important;
  padding: 20px 25px !important;
  .an_t {
    font-size: 16px !important;
    line-height: 1px !important;
  }
}

.review_input_form .review_bottom_wrap {
  position: relative;
}

.box_btn {
  padding: 0px;
  min-width: 105px;
}

.review_write_wrap {
  position: relative;
  // right: 10px;
  // top: 5px;
}

.review_score_box {
  display: flex;
  align-items: center !important;
  justify-content: center;
  margin-top: 10px;
}
.review_bottom_wrap {
  .review_score_box {
    justify-content: space-between;
  }
}
.l_box {
  display: flex;
  align-items: center;
}
.review_btn_wrap {
  position: static;
  display: inline-block;
}
</style>
